import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", amount = 0.35 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ index, kicker, title, className = "" }) => (
  <div className={`mb-16 md:mb-20 ${className}`}>
    <FadeUp>
      <p className="flex items-center gap-4 text-[11px] uppercase tracking-[0.35em] text-gold">
        <span className="font-serif text-base tracking-normal text-gold/70">{index}</span>
        <span className="h-px w-10 bg-gold/50" />
        {kicker}
      </p>
    </FadeUp>
    <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
      {title}
    </h2>
  </div>
);
